<template>
<div class=""  style="padding-top:70px;">
  <div class="row" >   
    <div class="col s12 m8 offset-m2 yo-align-center ">
      <img src="../assets/logo.png" style="width:100%;max-width:400px;"/> 
      <h2>Tesoreria {{$socio.sigla}} - Rinnovo Quote</h2>
    </div>
    <div class="col s12 m8 offset-m2">
      La piattaforma informatica per effettuare il rinnovo delle quote sociali {{$socio.sigla}}. 
      <br />
      Per accedere al gestionale bisogna inserire le proprie credenziali. 
    </div>
  </div>


  <el-form ref="form" :model="form" v-on:submit.prevent="beforeSubmit" :rules="rules" >
  
  <div class="row">
    <div class="col s12 m8 offset-m2" >   
      <h3 class="yo-text-bold">Area riservata</h3>
         <el-form-item class="no-label" prop="email">
         <el-input placeholder="Email" v-model.trim="form.email" auto-complete="off"></el-input>
         </el-form-item>
         <el-form-item class="no-label" prop="password">
         <el-input placeholder="Password" type="password" v-model.trim="form.password" auto-complete="off"  ></el-input>
         </el-form-item>

         <div class="row">
            <div class="col s6 offset-s6"><el-button type="success" v-on:click="beforeSubmit" style="width:100%;">Accedi</el-button></div>
         </div>

         <br />
         <hr />
    </div>
  </div>

  <div class="row pad">
    <div class="col s12 m4 offset-m2">
        <div style="height:180px;">
        <h3>Password dimenticata?</h3>
        Se hai dimenticato la tua password inserisci la tua email e clicca "Richiedi Password"<br />&#160;
        <el-form-item class="no-label" prop="recovery">
        <el-input  placeholder="Email" v-model.trim="form.recovery" auto-complete="off"></el-input>
        </el-form-item>
        </div>
        <div class="row">
          <div class="col s12"><el-button type="primary" v-on:click="getPassword" style="width:100%;">Richiedi Password</el-button></div>
        </div>
    </div>
    
    <div class="col s12 m4">
        <div style="height:180px;">
          <h3>Nuovo socio?</h3>
        Se non hai le credenziali per accedere e vuoi iscriverti alla {{$socio.sigla}} clicca "Nuovo Socio"
        </div>
        <div class="row">
          <div class="col s12"><el-button type="primary" v-on:click="newUser" style="width:100%;">Nuovo Socio</el-button></div>
        </div>
    </div>
  </div>

  </el-form>



  <div class="row" style="margin-top:30px;">   
    <div class="col s12 m8 offset-m2 yo-text-s">
      Ai fini di assicurare la sicurezza dei dati presenti all'interno del gestionale la tua sessione di lavoro sarà registrata. 
    </div>
  </div>



</div>
</template>

<script>
import emailRecovery from './Email-recovery.vue'
export default {
  name: 'login',
   created () {
    console.log("Created Login.vue")
    this.$teras.page.title = "Login"
    if(this.$teras.check.auth == true)
      this.$router.push('/home')

  },
  data() {
    return {
      termini:false,
      form: {
        email: '',
        password: '',
        recovery:''
      },
      rules: {
        email: [
          { required: true, message: 'L\'indirizzo email è obbligatorio', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'La password è obbligatoria', trigger: 'blur' }
        ]        
      }
    };
  },
  methods: {
    newUser(){
      document.location = 'https://simgeped.biomedia.net/diventasocio'
      
    },
    getPassword() {
      if(this.form.recovery!=''){

        
        this.$axios.query('fetchAll','SELECT cnt.* FROM bm_limmsy.contatto AS cnt LEFT JOIN bm_limmsy_simgeped.statoiscrizione AS si ON si.contatto=cnt.id AND si.societa='+this.$socio.societa+' WHERE si.dimesso=0 AND email = →recovery ',this.form).then((data) => {
          console.log("PASSWORD CHECK")
          if(data.result.length == 1 && data.result[0].id > 0){
            var html = this.$teras.renderVue(emailRecovery,{contatto:data.result[0]})
            this.$axios.email({from:'reunmaped@biomedia.net',oggetto:'Credenziali di accesso alla tesoreria REUMAPED',to:data.result[0].email,body:html}).then((data) => {
              console.log("Email con invio credenziali inviata")
            }).catch((error) => {
              console.log("Errore nell'invio della email con le credenziali")
              console.log(error)
            })


            
            var args = {idContatto: data.result[0].id, lingua:'ita'}
            this.$alert('Le abbiamo inviato le credenziali di accesso al suo indirizzo email', 'Recupero Password', {confirmButtonText: 'Chiudi' })

          }else{
            var msg = (data.result.length > 1) ? "Il suo indirizzo email è associato a più contatti, la preghiamo di contattare la segreteria per risolvereil problema!" : "Siamo spiacenti lei non risulta tra i nostri contatti"
            this.$alert(msg, "ATTENZIONE" ,{confirmButtonText: 'Chiudi' })
          }
        })

      }else{
        this.$notify.error({title: 'Errore',message: "La email è obbligatoria"})
      }
      
    },
    beforeSubmit(event) {
      event.preventDefault()
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.goSubmit()
        } else {
          return false;
        }
      });
    },
    goSubmit() {
      console.log(this.$teras)
      this.$axios.query('fetchRow','SELECT cnt.* FROM bm_limmsy.contatto AS cnt LEFT JOIN bm_limmsy_simgeped.statoiscrizione AS si ON si.contatto=cnt.id AND si.societa='+this.$socio.societa+' WHERE si.dimesso=0 AND email = →email AND cnt.password=→password',this.form).then((data) => {
        console.log("LOGIN CHECK")
        if(data.result.id > 0){
          this.$teras.utente = data.result
          this.$teras.app.routeInitial = this.$teras.app.routeAuth
          this.$teras.event.emit('login')
        }else{
          this.$alert("Le credenziali inserite non sono valide!", "ATTENZIONE" ,{confirmButtonText: 'Chiudi' })
          //this.$notify.error({title: 'Errore',message: "Le credenziali inserite non sono valide!"})
        }
      })
    }
  }
}
</script>
<style>
.login {
  margin: 0 auto;
  max-width: 700px;
}
.page-login{
  background:#fff;
  width: 100%;
}.login .el-form-item__content{
  margin:0 !important;

}
</style>
